import type {HTMLChakraProps} from '@chakra-ui/react';
import {forwardRef, useEditableContext} from '@chakra-ui/react';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';
import cx from 'clsx';

import {useEditableFieldsStyleConfig} from '../../theme-config';
import {EditableEditButton} from '../EditableFields';

export const EditableOffControls = forwardRef<HTMLChakraProps<'div'>, 'div'>((props, ref) => {
  const {children, className, ...rest} = props;
  const {isEditing} = useEditableContext();
  const styles = useEditableFieldsStyleConfig(props);

  return isEditing ? null : (
    <ChakraDiv __css={styles.controlsOff} className={cx(`editable-controls-off`, className)} {...rest} ref={ref}>
      {children || <EditableEditButton />}
    </ChakraDiv>
  );
});
